module.exports = __webpack_public_path__ + "static/media/MANA.a6f00975.svg";